import { useEffect, useRef, useState } from "react";
import Joyride, { ACTIONS, EVENTS, STATUS } from "react-joyride";
import "./TutorialStyles.scss";
import { useFlipcardState } from "../FlipCard/FlipcardStateContext";
import { update_tutorial_progress } from "../../network/communication";

function StudyTutorial(props) {
  const stepIndex = props.stepIndex;
  const setStepIndex = props.setStepIndex;

  const { isHoveredOrClicked } = useFlipcardState();

  const tutorialPhase = props.phase;
  const setTutorialPhase = props.setPhase;
  const slideLeft = props.slideLeft;
  const tutorialPhaseRef = useRef(tutorialPhase);
  const stepIndexRef = useRef(stepIndex);

  const PRE_RECALL_PHASE_BEGIN = 3;

  useEffect(() => {
    if (tutorialPhase === 0 && isHoveredOrClicked) {
      setStepIndex(0);
      setTutorialPhase(tutorialPhase + 1);
    } else if (tutorialPhase === 1 && isHoveredOrClicked === false) {
      setStepIndex(0);
      setTutorialPhase(tutorialPhase + 1);
    } else if (tutorialPhase === 2 && slideLeft) {
      setStepIndex(0);
      setTutorialPhase(tutorialPhase + 1);
    }
  }, [isHoveredOrClicked, slideLeft, tutorialPhase, setTutorialPhase]);

  const phase0Step = [
    {
      target: ".flip",
      title: "Flip the card",
      placement: "right",
      content: "Hover over the card to flip it.",
      disableBeacon: true,
      disableScrolling: true,
    },
  ];

  const phase1Step = [
    {
      target: ".flip",
      title: "Flip the card back",
      placement: "right",
      content: "Good job! Now stop hovering over it to flip it back.",
      disableBeacon: true,
      disableScrolling: true,
    },
  ];

  const phase2Step = [
    {
      target: ".arrow-right",
      title: "Using the Arrows",
      placement: "right",
      content: "Click the arrow to view the next card.",
      disableBeacon: true,
      disableScrolling: true,
    },
  ];

  const phase3Step = [
    {
      target: "body",
      title: "Good job!",
      placement: "center",
      content:
        "Great work! Recall Sessions are a great way to learn these flashcards, let's try it out!",
      disableBeacon: true,
      spotlightClicks: false,
    },

    {
      target: ".recall-button",
      title: "Recall Sessions",
      placement: "right",
      content: "Click Recall to begin your first Recall Session.",
      disableBeacon: true,
      spotlightClicks: true,
    },
  ];

  // After they've done their recall
  const phase4Step = [
    {
      target: "body",
      title: "Good job with your Recall Session!",
      placement: "center",
      content:
        "Amazing job with your Recall Session!",
    },
    {
      target: ".date-announcement",
      title: "Adding Your Test Date",
      placement: "right",
      content: (
        <>
          <img
            src="https://quizzynow.com/uploads/ProjectedProgress.png"
            alt="test date"
            style={{ width: "100%" }}
          ></img>
          <p>
            Got a test coming up? Just click 'Add Test Date' and let Quizzy
            know. It'll whip up a clever schedule to help you master those terms
            by your test day!<br></br>
          </p>
        </>
      ),
    },
    {
      target: ".date-announcement",
      title: "Adding Your Test Date",
      placement: "right",
      content: (
        <>
          <img
            src="https://quizzynow.com/uploads/ProjectedProgress.png"
            alt="smarter studying"
            style={{ width: "100%" }}
          ></img>
          <p>
            Ready for the next level?{" "}
            <a href="https://quizzynow.com/upgrade">Upgrade to Quizzy+</a> and
            unlock the Super learning plan. Quizzy gets even smarter, adding
            practice quizzes and even better AI methods to your schedule,
            helping you ace that test!
          </p>
        </>
      ),
    },
    {
      title: "Explore Quizzy",
      placement: "center",
      target: "body",
      content: (
        <>
          <p>
            Quizzy provides you with all sorts of charts, so you can see more information about your studying. Now it's your turn to explore all of Quizzy's features!
          </p>
        </>
      ),
    }
    /*{
      target: ".doughnut-charts",
      title: "Your Learning",
      placement: "right",
      content: (
        <>
          <p>
            These two charts show you how much time you've spent on Flashcards,
            Recall Sessions, and Quizzes for this set, as well as how much
            you've mastered.
          </p>
        </>
      ),
    },
    {
      target: ".most-difficult-terms",
      title: "Most Difficult Terms",
      placement: "right",
      content: (
        <>
          <img
            src="https://quizzynow.com/uploads/missedterms.png"
            alt="incorrect definitions"
            style={{ width: "100%" }}
          ></img>
          "
          <p>
            As you study, Quizzy tracks your toughest terms in a chart, showing
            you the ones you find tricky. <br></br>
            <a href="https://quizzynow.com/upgrade">Upgrade to Quizzy+</a> for
            exclusive access to this cool feature!
          </p>
          "
        </>
      ),
    },
    {
      target: ".recall_progress_friends_chart",
      title: "Compare with Friends",
      placement: "right",
      content: (
        <>
          <img
            src="https://quizzynow.com/uploads/RecallProgress.png"
            alt="Compare with Friends"
            style={{ width: "100%" }}
          ></img>
          <p>
            As you add friends on Quizzy and they study, you can compare your
            progress to theirs.
          </p>
        </>
      ),
    },
    {
      target: "body",
      title: "Study Tutorial Complete!",
      placement: "center",
      content: (
        <>
          <p>
            Great work getting through the study tutorial! Now, you should have
            a solid grasp of how everything works.
          </p>
        </>
      ),
    },*/
  ];

  const handleJoyrideCallback = (data) => {
    const { action, index, status, type } = data;
    if ([EVENTS.STEP_AFTER, EVENTS.TARGET_NOT_FOUND].includes(type)) {
      setStepIndex(index + (action === ACTIONS.PREV ? -1 : 1));
    } else if ([STATUS.FINISHED, STATUS.SKIPPED].includes(status)) {
      setStepIndex(0);
      setTutorialPhase(tutorialPhase + 1);
    }
  };

  const handleJoyrideBeforeRecallCallback = (data) => {
    const { action, index, status, type } = data;
    if ([EVENTS.STEP_AFTER, EVENTS.TARGET_NOT_FOUND].includes(type)) {
      setStepIndex(index + (action === ACTIONS.PREV ? -1 : 1));
    } else if ([STATUS.FINISHED, STATUS.SKIPPED].includes(status)) {
      if (tutorialPhase < PRE_RECALL_PHASE_BEGIN) {
        setStepIndex(0);
        setTutorialPhase(tutorialPhase + 1);
      }
    }
  };

  function updateContentForScreenWidth() {
    if (window.innerWidth <= 768) {
      phase0Step[0].content = "Tap the card to flip it";
      phase1Step[0].content = "Good job! Now tap it again to flip it back.";
      phase3Step[0].disableScrolling = false;
    }
  }

  // Call the function to check and update content on page load
  updateContentForScreenWidth();

  // Optional: You can also call this function on window resize if you want the content to update when the screen size changes dynamically
  window.addEventListener("resize", updateContentForScreenWidth);

  useEffect(() => {
    tutorialPhaseRef.current = tutorialPhase;
    stepIndexRef.current = stepIndex;
    update_tutorial_progress(
      "study",
      tutorialPhaseRef.current,
      stepIndexRef.current
    );
  }, [tutorialPhase, stepIndex]);

  return (
    <>
      {tutorialPhase === 0 && (
        <Joyride
          steps={phase0Step}
          disableScrolling={true}
          hideBackButton
          stepIndex={stepIndex}
          disableOverlay
          spotlightClicks={true}
          locale={{
            next: "Continue",
            close: "Continue",
            last: "Continue",
          }}
          //showProgress
          continuous
          hideCloseButton
          styles={{
            options: {
              backgroundColor: "#ffffff",
              textColor: "#747474",
              primaryColor: "#8358E8",
              fontFamily: "Plus Jakarta Sans",
            },
          }}
        ></Joyride>
      )}
      {tutorialPhase === 1 && (
        <Joyride
          steps={phase1Step}
          disableScrolling={true}
          hideBackButton
          stepIndex={stepIndex}
          disableOverlay
          spotlightClicks={true}
          locale={{
            next: "Continue",
            close: "Continue",
            last: "Continue",
          }}
          //showProgress
          continuous
          hideCloseButton
          styles={{
            options: {
              backgroundColor: "#ffffff",
              textColor: "#747474",
              primaryColor: "#8358E8",
              fontFamily: "Plus Jakarta Sans",
            },
          }}
        ></Joyride>
      )}
      {tutorialPhase === 2 && (
        <Joyride
          steps={phase2Step}
          hideBackButton
          stepIndex={stepIndex}
          disableOverlay
          spotlightClicks={true}
          callback={handleJoyrideCallback}
          locale={{
            next: "Continue",
            close: "Continue",
            last: "Continue",
          }}
          //showProgress
          continuous
          hideCloseButton
          styles={{
            options: {
              backgroundColor: "#ffffff",
              textColor: "#747474",
              primaryColor: "#8358E8",
              fontFamily: "Plus Jakarta Sans",
            },
          }}
        ></Joyride>
      )}
      {tutorialPhase === 3 && (
        <Joyride
          steps={phase3Step}
          disableScrolling={true}
          hideBackButton
          stepIndex={stepIndex}
          spotlightClicks={true}
          callback={handleJoyrideBeforeRecallCallback}
          locale={{
            next: "Continue",
            close: "Continue",
            last: "Continue",
          }}
          //showProgress
          continuous
          hideCloseButton
          styles={{
            options: {
              backgroundColor: "#ffffff",
              textColor: "#747474",
              primaryColor: "#8358E8",
              fontFamily: "Plus Jakarta Sans",
            },
          }}
        ></Joyride>
      )}
      {tutorialPhase === 4 && (
        <Joyride
          steps={phase4Step}
          disableScrolling={true}
          hideBackButton
          stepIndex={stepIndex}
          callback={handleJoyrideCallback}
          locale={{
            next: "Continue",
            close: "Continue",
            last: "Continue",
          }}
          //showProgress
          continuous
          hideCloseButton
          styles={{
            options: {
              backgroundColor: "#ffffff",
              textColor: "#747474",
              primaryColor: "#8358E8",
              fontFamily: "Plus Jakarta Sans",
            },
          }}
        ></Joyride>
      )}
    </>
  );
}

export default StudyTutorial;
